module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-cover",
    class: _vm.cardPosition
  }, [_c('resize-observer', {
    on: {
      "notify": _vm.resizeCards
    }
  }), (_vm.isCoverReady) ? _c(("article-cover-card-" + _vm.nid), {
    ref: "cardCoverContent",
    tag: "component",
    attrs: {
      "nid": _vm.nid,
      "showAnimation": _vm.showAnimation,
      "parentInitFunctions": _vm.parentInitFunctions
    }
  }) : _vm._e(), (_vm.articleType === 'live') ? [_c('SpeechBalloonLabel', {
    attrs: {
      "node": _vm.node,
      "size": "large-responsive",
      "mainComponent": "article-cover-card",
      "showShadow": ""
    }
  })] : _vm._e(), _c('div', {
    staticClass: "button-wrapper play-button-wrapper"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isVideoCard && _vm.showVideoPlayButton),
      expression: "isVideoCard && showVideoPlayButton"
    }],
    staticClass: "play-button",
    on: {
      "click": _vm.playVideo
    }
  }, [_c('svg-video-play-icon')], 1)]), _c('div', {
    staticClass: "isCountdownCard",
    attrs: {
      "alt": "isCountDownCard"
    }
  }, [(!_vm.isEmpty(_vm.countDown)) ? _c('widget-count-down', {
    attrs: {
      "countDown": _vm.countDown
    }
  }) : _vm._e()], 1), (_vm.actionText && _vm.showAction) ? _c('div', {
    ref: "card-action",
    staticClass: "card-action",
    class: {
      cardInvisible: _vm.actionToggle, up: _vm.actionUp
    },
    on: {
      "click": _vm.toArticle
    }
  }, [_c('div', {
    staticClass: "card-action-icon-wrapper"
  }, [_c('svg-arrow-down')], 1), _c('div', {
    staticClass: "card-action-text"
  }, [_vm._v(_vm._s(_vm.actionText))])]) : _vm._e(), _vm._t("arrowsHover")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-caa199b2","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/node/CardCover.vue
// module id = 1783
// module chunks = 1